import {invokeApig} from "../../libs/awsLib";
import {getUserApiData} from "../../utils/UserUtils";
import Paths from "../paths";

export function getResultSummary(ResultID, Data, {ClientID, LocalUserID} = {}) {
    const {_LocalUserID, _ClientID} = getUserApiData({ClientID, LocalUserID});
    return invokeApig({
        ...Paths.getResultSummary({
            clientID: _ClientID,
            localUserID: _LocalUserID,
        }),
        body: {
            ResultID,
            Data,
        },
    });
}
